import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteReportsRequest, deleteReportsRequestError, deleteReportsRequestSuccess } from '../../slices/Query/DeleteReportsSlice';

export const DeleteReportsAPI = (id) => {
    const url = `${endpoints.deleteReports}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteReportsRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteReportsRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteReportsRequestError(_error));
        }
    };
};
